import { Grid, Typography } from "@mui/material";

const SpinnerControls = ({
  value,
  onChange,
  onDecrement,
  onIncrement,
  condition,
  readOnly,
  width,
  headingColor
}) => (
  <Grid display="flex" alignItems="flex-start" height="40px" border="1px solid #b8bdc9" width={width} mb="16px">
    <Grid onClick={condition ? null : onDecrement} sx={buttonStyle}>
      <Typography variant="h5">-</Typography>
    </Grid>
    <input
      type="number"
      value={value === 0 ? '' : value}
      onChange={onChange}
      readOnly={readOnly || condition}
      style={{
        border: '1px solid transparent',
        borderRadius: '3px',
        padding: '10px',
        width: '238px',
        height: '38px',
        fontSize: '12px',
        fontWeight: 700,
        lineHeight: '38px',
        color: headingColor,
        textAlign: 'center',
      }}
    />
    <Grid onClick={condition ? null : onIncrement} sx={buttonStyle}>
      <Typography variant="h5">+</Typography>
    </Grid>
  </Grid>
);

const buttonStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  bgcolor: '#f4f4f7',
  width: '36px',
  height: '38px',
  cursor: 'pointer'
};

export default SpinnerControls;
